import { ReducerBuilder } from './reducerBuilder';
import { CreateAccountRequest } from 'acscp/api/requests/createAccountRequest';
import { CreateAccountResponse } from 'acscp/api/models/createAccountResponse';

export const createAccountReducer =
    new ReducerBuilder<CreateAccountResponse>({
        confirmationEmailSenderAddress: ''
    })
        .successfulRequestCase(CreateAccountRequest, (state, response: CreateAccountResponse) => response)
        .build();
